import { CheckNotes, InspectionCase, SummaryNotes } from '../inspection-cases';
import { Cases, Inspection } from '../inspection.dto';
import { WaterNetworkCharacterization } from '../water-network-characterization.dto';
import { PumpRoomInstallation } from './pump-room-installation';
import { SprinklerSystemInstallation } from './sprinkler-Installation';

export class InspectionInstallationDto extends InspectionCase {
  sprinklerSystemInstallation?: SprinklerSystemInstallation;
  pumpRoomInstallation?: PumpRoomInstallation;
  waterNetworkCharacterization?: WaterNetworkCharacterization;
  companion?: string;
  summaryNotes?: SummaryNotes[];
}

export class InspectionInstallation
  extends InspectionInstallationDto
  implements Inspection
{
  constructor(
    data: InspectionInstallationDto = {
      title: 'בדיקת התקנת מערכות מתזים במים',
      isApplicable: true,
      summaryNotes: []
    }
  ) {
    super(data);
    this.summaryNotes = data.summaryNotes;
    this.sprinklerSystemInstallation = new SprinklerSystemInstallation(
      data.sprinklerSystemInstallation
    );
    this.pumpRoomInstallation = new PumpRoomInstallation(
      data.pumpRoomInstallation
    );
    this.waterNetworkCharacterization = new WaterNetworkCharacterization(
      data.waterNetworkCharacterization
    );
    this.companion = data.companion;
  }

  setInspectionStatus(): void {
    this.sprinklerSystemInstallation.setInspectionStatus();
    this.pumpRoomInstallation.setInspectionStatus();
    this.waterNetworkCharacterization.setInspectionStatus();

    this.isPassed =
      this.sprinklerSystemInstallation.isPassed &&
      this.pumpRoomInstallation.isPassed &&
      this.waterNetworkCharacterization.isPassed;
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.sprinklerSystemInstallation.getNotes(),
      ...this.pumpRoomInstallation.getNotes(),
      ...this.waterNetworkCharacterization.getNotes()
    ];
  }

  removeNonApplicable?(): void {}

  setAsApplicable?(): void {
    this.isApplicable = true;
    this.sprinklerSystemInstallation.setAsApplicable();
    this.pumpRoomInstallation.setAsApplicable();
    this.waterNetworkCharacterization.setAsApplicable();
  }

  getCases(): Cases[] {
    return [
      {
        title: this.sprinklerSystemInstallation.title,
        cases: [
          this.sprinklerSystemInstallation.main,
          this.sprinklerSystemInstallation.waterSupplySource,
          this.sprinklerSystemInstallation.fireExtinguishingSystems,
          this.sprinklerSystemInstallation.pressureSystem,
          this.sprinklerSystemInstallation.valvesPlumbingFittings,
          this.sprinklerSystemInstallation.preactionSystemsInstallation,
          this.sprinklerSystemInstallation.drySystems,
          this.sprinklerSystemInstallation.floodingCoolingExtinguishingSystems,
          this.sprinklerSystemInstallation.racksAndReinforcement,
          this.sprinklerSystemInstallation.earthquakeReinforcements,
          this.sprinklerSystemInstallation.alarmCheck,
          this.sprinklerSystemInstallation.foamCenterInstallation,
          this.sprinklerSystemInstallation.foamFloodingSystems,
          this.sprinklerSystemInstallation.closedFoamSpraySystems
        ]
      },
      {
        title: this.pumpRoomInstallation.title,
        cases: [
          this.pumpRoomInstallation.pumpRoomInstallationMain,
          this.pumpRoomInstallation.waterReservoirInstallation,
          this.pumpRoomInstallation.pumps[0]
            ?.fireExtinguishingPumpsInstallation,
          this.pumpRoomInstallation.pumps[0]?.dieselShutdownPump,
          this.pumpRoomInstallation.pumps[0]?.electricShutdownPump,
          this.pumpRoomInstallation.pumps[0]?.waterFlowTest,
          this.pumpRoomInstallation.pumps[0]?.waterFlowData
        ]
      },
      {
        title: this.waterNetworkCharacterization.title,
        cases: [this.waterNetworkCharacterization]
      }
    ];
  }
}
